import { Component, OnInit } from '@angular/core';
import { InlineEditComponent } from '../../../../shared/components/inline-edit/inline-edit.component';
import { debounceTime } from 'rxjs/operators';
import { InvitationOptionsComponent } from '../../../../shared/components/invitation-options-component/invitation-options.component';
import { Invitation } from '../../../../shared/components/invitation-options-component/invitation';
import { OperatorService } from '../../services/operator.service';

@Component({
  selector: 'app-operator-invitations',
  templateUrl: './operator-invitations.component.html',
  styleUrls: ['./operator-invitations.component.scss']
})
export class OperatorInvitationsComponent implements OnInit {
  public settings = {
    actions: 'false',
    hideSubHeader: true,
    columns: {
      email: {
        title: 'Email',
        type: 'custom',
        renderComponent: InlineEditComponent,
        onComponentInitFunction: (instance: InlineEditComponent) => {
          instance.valueEmitter
            .pipe(debounceTime(200))
            .subscribe(value => {
              const invitation = this.invitations.find(e => e.isDraft === true);
              if (invitation) {
                invitation.email = value;
              }
            });
        },
        valuePrepareFunction: (rowData: any, cell: any, value: any) => {
          return {
            type: 'email',
            data: rowData,
            cell
          };
        }
      },
      lastName: {
        title: 'Nume'
      },
      firstName: {
        title: 'Prenume'
      },
      cnp: {
        title: 'CNP'
      },
      status: {
        title: 'Status'
      },
      optiuni: {
        title: 'Optiuni',
        type: 'custom',
        renderComponent: InvitationOptionsComponent,
        valuePrepareFunction: (rowData: any, cell: any, value: any) => {
          return {
            data: rowData,
            cell
          };
        },
        onComponentInitFunction: (instance: InvitationOptionsComponent) => {
          instance.inactivate.subscribe((row: Invitation) => {
            this.operatorService.removeInvitation(row.id)
              .subscribe(value => {
                this.updateInvitation(value);
              });
          });
          instance.delete.subscribe((row: Invitation) => {
            if (!!row.isDraft) {
              this.removeInvitation(row);
            } else {
              this.operatorService.removeInvitation(row.id)
                .subscribe(() => {
                  this.removeInvitation(row);
                });
            }
          });
          instance.sendInvite.subscribe((row: Invitation) => {
            this.operatorService.addInvitation(row).subscribe((invitation: Invitation) => {
              this.isAddingInvitation = false;
              this.updateInvitation(invitation);
            });
          });
        },
      },
    }
  };

  public isAddingInvitation = false;
  public invitations: Invitation[] = [];

  constructor(
    private operatorService: OperatorService
  ) { }

  ngOnInit(): void {
    this.operatorService.getInvitations()
      .subscribe((invitations: Invitation[]) => this.invitations = invitations);
  }

  removeInvitation(invitation: Invitation): void {
    const exists = this.invitations.some(e => e.id === invitation.id);
    if (exists) {
      this.invitations = this.invitations.filter(e => e.id !== invitation.id);
    } else {
      this.invitations = this.invitations.filter(e => e.isDraft !== true);
    }
  }

  updateInvitation(invitation: Invitation): void {
    const exists = this.invitations.some(e => e.id === invitation.id);
    if (exists) {
      this.invitations = this.invitations.map(e => e.id !== invitation.id ? e : invitation);
    } else {
      this.invitations = this.invitations.map(e => e.isDraft === true ? invitation : e);
    }
  }

  addInvitation(): void {
    const invitationList = [];
    const newEntry: Invitation = {
      isDraft: true,
      email: ''
    };
    this.invitations.unshift(newEntry);
    invitationList.push(...this.invitations);
    this.invitations = invitationList;
    this.isAddingInvitation = true;
  }

}
